var MEIIYO_DOMAIN='ebonycrown.myshopify.com';
var MEIIYO_TOKEN='2b4ac33810ce57b25af13aa19e59e989';
var MEIIYO_PROXY='https://meiiyo-proxy.vercel.app/api/claude';
var MEIIYO_VARIANTS={
  'NOOD Pimple Patch - Espresso':'gid://shopify/ProductVariant/49232223011132',
  'NOOD Pimple Patch - Hazelnut':'gid://shopify/ProductVariant/50560416350524',
  'NOOD Pimple Patch - Sandstone':'gid://shopify/ProductVariant/52296356757820',
  'NOOD Pimple Patch - Glass':'gid://shopify/ProductVariant/9891800908092'
};
var MEIIYO_PRODUCTS={
  'NOOD Pimple Patch - Espresso':{shade:'Espresso',price:'$16',url:'https://www.meiiyo.com/products/nood-pimple-patch',img:'https://www.meiiyo.com/cdn/shop/files/NOODEspresso4.jpg?v=1767983661&width=200',desc:'Ultra-thin tone-matched hydrocolloid patch for deep and rich skin tones. Blends seamlessly into your complexion, day or night.',tags:['Tone-matched','Hydrocolloid','20 patches','2 sizes']},
  'NOOD Pimple Patch - Hazelnut':{shade:'Hazelnut',price:'$16',url:'https://www.meiiyo.com/products/nood-pimple-patch',img:'https://www.meiiyo.com/cdn/shop/files/3.jpg?v=1767983661&width=200',desc:'Ultra-thin tone-matched hydrocolloid patch for medium-dark to dark skin tones. Barely noticeable coverage with real healing power.',tags:['Tone-matched','Hydrocolloid','20 patches','2 sizes']},
  'NOOD Pimple Patch - Sandstone':{shade:'Sandstone',price:'$16',url:'https://www.meiiyo.com/products/nood-pimple-patch',img:'https://www.meiiyo.com/cdn/shop/files/Sandstone_3b1b9ed8-8346-43bd-a0fc-811ecea37760.jpg?v=1767983661&width=200',desc:'Ultra-thin tone-matched hydrocolloid patch for light-medium to medium skin tones. Natural matte finish under or over makeup.',tags:['Tone-matched','Hydrocolloid','20 patches','2 sizes']},
  'NOOD Pimple Patch - Glass':{shade:'Clear',price:'$14',url:'https://www.meiiyo.com/products/nood-pimple-patch-glass',img:'https://www.meiiyo.com/cdn/shop/files/NOOD_Pimple_Patch_-_Glass.jpg?v=1767982538&width=200',desc:'Crystal-clear medical-grade hydrocolloid patch for fair and light skin tones. Fully invisible under makeup, day or night.',tags:['Crystal clear','Fair to Light','30 patches','3 sizes']}
};
var MEIIYO_TONES=[
  {grid:'mg-fair',tones:[{c:'#F8E8D4',l:'Fair',n:'NOOD Pimple Patch - Glass'},{c:'#F2D9BC',l:'Light',n:'NOOD Pimple Patch - Glass'}]},
  {grid:'mg-sandstone',tones:[{c:'#E8C49A',l:'Light-Medium',n:'NOOD Pimple Patch - Sandstone'},{c:'#D4A574',l:'Medium',n:'NOOD Pimple Patch - Sandstone'}]},
  {grid:'mg-hazelnut',tones:[{c:'#B8845A',l:'Medium-Dark',n:'NOOD Pimple Patch - Hazelnut'},{c:'#8C5E3C',l:'Dark',n:'NOOD Pimple Patch - Hazelnut'}]},
  {grid:'mg-espresso',tones:[{c:'#6B3D20',l:'Deep',n:'NOOD Pimple Patch - Espresso'},{c:'#3D2010',l:'Rich',n:'NOOD Pimple Patch - Espresso'}]}
];
var MEIIYO_QD={
  mq1:['Active breakouts','Post-acne dark marks','Blackheads/whiteheads','Cystic/hormonal acne','Redness and inflammation','Uneven texture'],
  mq2:['Oily','Dry','Combination','Normal','Sensitive'],
  mq3:['Mild (1-3 spots)','Moderate (4-10 spots)','Severe (10+ spots)','Hormonal flares']
};
var MEIIYO_LMSGS=['Analyzing your skin profile...','Matching to NOOD shades...','Crafting your derm tips...','Almost ready...'];
var mSt={photo:null,tone:null,shade:null,q1:null,q2:null,q3:null};

function mShowToast(msg){
  var t=document.getElementById('mToast');
  t.textContent=msg;t.classList.add('mshow');
  setTimeout(function(){t.classList.remove('mshow');},2800);
}

function mGo(n){
  [1,2,3,4].forEach(function(i){
    document.getElementById('ms'+i).classList.toggle('mv',i===n);
    var b=document.getElementById('mn'+i);
    if(b){b.classList.remove('ma','md');if(i===n)b.classList.add('ma');else if(i<n)b.classList.add('md');}
  });
  document.getElementById('meiiyo-skin-advisor').scrollIntoView({behavior:'smooth',block:'start'});
}

function mOnPhoto(e){
  var f=e.target.files[0];if(!f)return;
  var r=new FileReader();
  r.onload=function(ev){
    mSt.photo=ev.target.result;
    var p=document.getElementById('mPhotoPreview');
    p.src=ev.target.result;p.style.display='block';
  };
  r.readAsDataURL(f);
}

function mTickLoader(){
  var i=0;var el=document.getElementById('mLmsg');
  return setInterval(function(){if(++i<MEIIYO_LMSGS.length)el.textContent=MEIIYO_LMSGS[i];},1800);
}

function mBuildPrompt(hasPhoto){
  var catalog=Object.keys(MEIIYO_PRODUCTS).map(function(n){
    var p=MEIIYO_PRODUCTS[n];
    return '- '+n+' ('+p.price+'): '+p.desc;
  }).join('\n');
  return 'You are the MEiiYO AI skin advisor. Only recommend from the MEiiYO NOOD catalog below.\n\nTone mapping: Fair/Light=Glass, Light-Medium/Medium=Sandstone, Medium-Dark/Dark=Hazelnut, Deep/Rich=Espresso\n\nCatalog:\n'+catalog+'\n\nCustomer:\n- Skin tone: '+(mSt.tone||'Not specified')+'\n- Suggested patch: '+(mSt.shade?MEIIYO_PRODUCTS[mSt.shade].shade:'Glass')+'\n- Concern: '+mSt.q1+'\n- Skin type: '+mSt.q2+'\n- Severity: '+mSt.q3+'\n- '+(hasPhoto?'Photo uploaded.':'No photo.')+'\n\nRules: 1) Primary = tone-matched patch. Add Glass as secondary only if severe/cystic and tone is not already Glass. 2) dermTips: 2-3 tips, 2 sentences each. 3) Return ONLY valid JSON, no markdown.\n\nJSON: {"profile":{"skinTone":"string","skinType":"string","concern":"string"},"products":[{"name":"exact catalog name","whyThisOne":"string"}],"dermTips":[{"title":"string","tip":"string"}]}';
}

async function mAnalyze(){
  document.getElementById('mErrMsg').style.display='none';
  if(!mSt.q1||!mSt.q2||!mSt.q3){document.getElementById('mErrMsg').style.display='block';return;}
  mGo(4);
  document.getElementById('mLd').style.display='block';
  document.getElementById('mRdiv').style.display='none';
  document.getElementById('mEdiv').style.display='none';
  var ticker=mTickLoader();
  var msgContent;
  if(mSt.photo){
    var base64=mSt.photo.split(',')[1];
    var mtype=mSt.photo.split(';')[0].split(':')[1]||'image/jpeg';
    msgContent=[{type:'image',source:{type:'base64',media_type:mtype,data:base64}},{type:'text',text:mBuildPrompt(true)}];
  } else {
    msgContent=mBuildPrompt(false);
  }
  try{
    var res=await fetch(MEIIYO_PROXY,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({model:'claude-sonnet-4-20250514',max_tokens:1000,messages:[{role:'user',content:msgContent}]})});
    var data=await res.json();
    clearInterval(ticker);
    var raw=(data.content||[]).map(function(b){return b.text||'';}).join('');
    var parsed;
    try{parsed=JSON.parse(raw.replace(/```json|```/g,'').trim());}catch(e){throw new Error('parse');}
    mRender(parsed);
  }catch(err){
    clearInterval(ticker);
    document.getElementById('mLd').style.display='none';
    document.getElementById('mEdiv').style.display='block';
  }
}

function mRender(d){
  document.getElementById('mLd').style.display='none';
  document.getElementById('mRdiv').style.display='block';
  var p=d.profile||{};
  document.getElementById('mSprof').innerHTML=[
    {v:p.skinTone||mSt.tone||'-',l:'Skin tone'},
    {v:p.skinType||mSt.q2||'-',l:'Skin type'},
    {v:p.concern||mSt.q1||'-',l:'Concern'}
  ].map(function(s){return '<div class="mpstat"><div class="mv2">'+s.v+'</div><div class="ml">'+s.l+'</div></div>';}).join('');

  document.getElementById('mPrecs').innerHTML=(d.products||[]).map(function(rec){
    var key=Object.keys(MEIIYO_PRODUCTS).find(function(k){return k===rec.name||k.toLowerCase().includes((rec.name||'').toLowerCase());});
    var pr=key?MEIIYO_PRODUCTS[key]:null;if(!pr)return'';
    var sk=key.replace(/[^a-zA-Z0-9]/g,'_');
    return '<div class="mpcard"><div class="mptop"><div class="mpimg"><img src="'+pr.img+'" alt="'+key+'" width="68" height="68" onerror="this.style.display=\'none\'"></div><div class="mpbody"><div class="mpname">'+key+'</div><div class="mpshade">'+pr.shade+' &middot; '+pr.price+'</div><div class="mpdesc">'+(rec.whyThisOne||pr.desc)+'</div><div class="mptags">'+pr.tags.slice(0,4).map(function(t,i){return '<span class="mptag'+(i===0?' mac':'')+'">'+t+'</span>';}).join('')+'</div></div></div><div class="mpacts"><button class="mbtnc" id="mCBtn_'+sk+'" onclick="mAddCart(\''+key+'\',\''+sk+'\',\''+pr.url+'\')"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1h2l1.5 7.5h6l1.5-5H3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="5.5" cy="12" r="1" fill="currentColor"/><circle cx="9.5" cy="12" r="1" fill="currentColor"/></svg>Add to cart</button><a href="'+pr.url+'" target="_blank" rel="noopener"><button class="mbtnv">View &rarr;</button></a></div><div class="mcmsg" id="mCMsg_'+sk+'"><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 6.5l3 3 6-6" stroke="#4A8C6A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>Added! <a id="mCLink_'+sk+'" href="#" target="_blank">Go to checkout &rarr;</a></div><div class="mcerr" id="mCErr_'+sk+'">Could not add. <a href="'+pr.url+'" target="_blank">Shop directly &rarr;</a></div></div>';
  }).join('');

  document.getElementById('mDrecs').innerHTML=(d.dermTips||[]).map(function(t){
    return '<div class="mdrec"><div class="mdtitle">'+t.title+'</div><p>'+t.tip+'</p></div>';
  }).join('');
}

async function mAddCart(productKey,sk,fallbackUrl){
  var btn=document.getElementById('mCBtn_'+sk);
  var msgEl=document.getElementById('mCMsg_'+sk);
  var errEl=document.getElementById('mCErr_'+sk);
  btn.disabled=true;
  btn.innerHTML='<div style="width:14px;height:14px;border:2px solid rgba(255,255,255,.4);border-top-color:#fff;border-radius:50%;animation:mspin .8s linear infinite;display:inline-block;"></div>';
  var variantId=MEIIYO_VARIANTS[productKey];
  if(!variantId){window.open(fallbackUrl,'_blank');return;}
  var query='mutation cartCreate($input:CartInput!){cartCreate(input:$input){cart{checkoutUrl}userErrors{message}}}';
  try{
    var res=await fetch('https://'+MEIIYO_DOMAIN+'/api/2024-01/graphql.json',{method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':MEIIYO_TOKEN},body:JSON.stringify({query:query,variables:{input:{lines:[{merchandiseId:variantId,quantity:1}]}}})});
    var json=await res.json();
    var url=json.data&&json.data.cartCreate&&json.data.cartCreate.cart&&json.data.cartCreate.cart.checkoutUrl;
    if(!url)throw new Error('no url');
    btn.className='mbtnc mok';
    btn.innerHTML='<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l3.5 3.5L12 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Added!';
    document.getElementById('mCLink_'+sk).href=url;
    msgEl.style.display='flex';errEl.style.display='none';
    mShowToast('Added to cart!');
  }catch(e){
    btn.disabled=false;
    btn.innerHTML='<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1h2l1.5 7.5h6l1.5-5H3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="5.5" cy="12" r="1" fill="currentColor"/><circle cx="9.5" cy="12" r="1" fill="currentColor"/></svg>Add to cart';
    errEl.style.display='block';
    window.open(fallbackUrl,'_blank');
  }
}

async function mSubscribe(){
  var input=document.getElementById('mEmailInput');
  var btn=document.getElementById('mSubBtn');
  var err=document.getElementById('mEcapErr');
  var email=input.value.trim();
  err.style.display='none';
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){err.style.display='block';return;}
  btn.disabled=true;btn.textContent='Saving...';
  var query='mutation customerCreate($input:CustomerCreateInput!){customerCreate(input:$input){customer{id}customerUserErrors{message}}}';
  try{
    var res=await fetch('https://'+MEIIYO_DOMAIN+'/api/2024-01/graphql.json',{method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':MEIIYO_TOKEN},body:JSON.stringify({query:query,variables:{input:{email:email,acceptsMarketing:true,tags:['skin-matcher','ai-match','meiiyo-app']}}})});
    var json=await res.json();
    var errs=json.data.customerCreate.customerUserErrors||[];
    if(errs.length&&!errs[0].message.toLowerCase().includes('taken'))throw new Error(errs[0].message);
    document.getElementById('mEcapForm').style.display='none';
    document.getElementById('mEcapSuc').style.display='block';
    mShowToast('Welcome to MEiiYO!');
  }catch(e){
    btn.disabled=false;btn.textContent='Join';
    err.textContent='Something went wrong. Please try again.';err.style.display='block';
  }
}

function mRestart(){
  mSt={photo:null,tone:null,shade:null,q1:null,q2:null,q3:null};
  document.getElementById('mPhotoPreview').style.display='none';
  document.getElementById('mFi').value='';
  document.getElementById('mTlbl').textContent='Tap a swatch to select';
  document.querySelectorAll('.mswatch').forEach(function(s){s.classList.remove('msel');});
  document.querySelectorAll('.mchip').forEach(function(c){c.classList.remove('msel');});
  document.getElementById('mEmailInput').value='';
  document.getElementById('mEcapForm').style.display='flex';
  document.getElementById('mEcapSuc').style.display='none';
  mGo(1);
}

document.addEventListener('DOMContentLoaded',function(){
  MEIIYO_TONES.forEach(function(group){
    var g=document.getElementById(group.grid);
    if(!g)return;
    group.tones.forEach(function(t){
      var d=document.createElement('div');
      d.className='mswatch';d.style.background=t.c;d.title=t.l;
      var pill=document.createElement('span');
      pill.className='mspill';
      pill.textContent=MEIIYO_PRODUCTS[t.n].shade;
      d.appendChild(pill);
      d.onclick=function(){
        document.querySelectorAll('.mswatch').forEach(function(s){s.classList.remove('msel');});
        d.classList.add('msel');
        mSt.tone=t.l;mSt.shade=t.n;
        document.getElementById('mTlbl').textContent=t.l+' \u2014 matched to NOOD '+MEIIYO_PRODUCTS[t.n].shade;
      };
      g.appendChild(d);
    });
  });

  Object.keys(MEIIYO_QD).forEach(function(id){
    var c=document.getElementById(id);
    if(!c)return;
    MEIIYO_QD[id].forEach(function(o){
      var b=document.createElement('button');
      b.className='mchip';b.textContent=o;
      b.onclick=function(){
        c.querySelectorAll('.mchip').forEach(function(x){x.classList.remove('msel');});
        b.classList.add('msel');
        mSt[id.replace('mq','q')]=o;
      };
      c.appendChild(b);
    });
  });
});